<template>
  	<div class="ranking-container" v-infinite-scroll="load" >
			<div class="btn_back" @click="$emit('changePage', 0)">
				<img src="../../../assets/img/cdjs-back.png" alt="">
			</div>
  		<div class="ranking-table">
  			<div class="ranking-table-content">
  				<div id="tab1">
  					<ul>
  					   <li  :class="{'now': tableBr}" @click="changeTable(true)">个人榜</li>
  					   <li :class="{'now': !tableBr}" @click="changeTable(false)">团队榜</li>
  					</ul>
  				</div>
  				<div id="tablist1" >
  					<div class="tablist block" v-show="tableBr">
  						<span class="ranking-personal-table">
  							<span class="ranking-personal-tables">
  								<!-- <span class="ranking-personal-number mgr10">{{rank}}</span> -->
                  <RankPic :rank="rank"></RankPic>
  								<span>
  									<img :src="userImage" class="head-img">
  									<span class="ranking-personal-text">
  										<span class="ranking-personal-name">{{realName}}</span>
  										<br/>
  										<span class="ranking-personal-department">{{position}}</span>
  									</span>
  								</span>
  								<span class="ranking-personal-fraction">{{totalScore}}<span>分</span></span>
  							</span>
  							<!---->
  							<span class="ranking-personal-tabli">
  								<ul>
  									<li v-for="item in pRankList" :key="item.uid">
  										<!-- <span class="ranking-personal-number"><img src="../../../assets/img/personal-one.png" class="ranking-top-one"></span> -->
  										<RankPic :rank="item.rank"></RankPic>
                      <span>
  											<img :src="item.image?item.image:baseImg" class="head-img">
  											<span class="ranking-personal-text">
  												<span class="ranking-personal-name">{{item.realName}}</span>
  												<br/>
  												<span class="ranking-personal-department">{{item.position}}</span>
  											</span>
  										</span>
  										<span class="ranking-personal-fraction">{{item.score}}<span>分</span></span>
  									</li>
  								</ul>
  							</span>
  						</span>
  					</div>

  					<div class="tablist block" v-show="!tableBr">
  						<div class="ranking-personal-tables">
  							<!-- <span class="ranking-personal-number mgr10">{{tRank}}</span> -->
                <RankPic :rank="tRank"></RankPic>
  							<span class="ranking-personal-company">
  								{{departmentName}}
  							</span>
  							<span class="ranking-personal-fraction">{{tScore}}<span>分</span></span>
  						</div>
  						<div class="ranking-personal-comli">
  							<ul>
  								<li v-for="item in tRankList" :key="item.departmentId">
  									<!-- <span class="ranking-personal-number"><img src="../../../assets/img/personal-one.png" class="ranking-top-one"></span> -->
  									<RankPic :rank="item.rank"></RankPic>
                    <span class="ranking-personal-company">
  										{{item.departmentName}}
  									</span>
  									<span class="ranking-personal-fraction">{{item.score}}<span>分</span></span>
  								</li>
  							</ul>
  						</div>
  					</div>
  				</div>
  			</div>
  		</div>
  	</div>
</template>

<script>
  import {ApiGetMyScore, ApiGetActivityScoreRank, ApiGetMyTeamScore, ApiGetTeamScoreRank} from '../../../net/cdjs/index.js'
  import store from '../../../vuex/store.js'
  import RankPic from './rankPic.vue'
  export default {
    data: function () {
      return {
        baseImg: 'http://statics.sgn.7east.cn/photo/20201207172318.png',
        tableBr: true,
        PNum: 1,
        PSize: 10,
        TNum: 1,
        TSize: 10,
        totalScore: 0,
        rank: 0,
        realName: '',
        position: '',
        userImage: '',
        departmentId: 0,
        departmentName: '',
        tRank: 0,
        tScore: 0,
        pRankList: [],
        tRankList: [],
        status: 'more',
        tStatus: 'more'
      }
    },
    store,
    components:{RankPic},
    methods: {
      changeTable: function (br) {
        this.tableBr = br
      },
      getMyScore: function () {
        const params = {
          id: this.$store.state.cdjsID
        }
        ApiGetMyScore(params).then(res=>{
          if (res.code == 200){
            this.totalScore = res.value.totalScore
            this.rank = res.value.rank
            this.realName = res.value.realName
            this.position = res.value.position
            this.userImage = res.value.userImage || this.baseImg
          }
        })
      },
      getMyTeamScore: function () {

        ApiGetMyTeamScore({}).then(res=>{
          if (res.code == 200) {
            this.departmentId = res.value.departmentId
            this.departmentName = res.value.departmentName
            this.tRank = res.value.rank
            this.tScore = res.value.score
          }
        })
      },
      getActivityScoreRank: function (addBr) {
				this.status = 'loading'
				if (addBr) {
					this.PNum++
				} else {
					this.PNum = 1
				}
        const params = {
          pageNum: this.PNum,
          pageSize: this.PSize,
          activityId: this.$store.state.cdjsID,
          platform: 'pc'
        }
        ApiGetActivityScoreRank(params).then(res=>{
          if (res.code == 200) {
            const _list = res.pc.details
						if (_list.length < this.PSize) {
							this.status = 'noMore'
						} else {
							this.status = 'more'
						}
						if (addBr) {
							this.pRankList = this.pRankList.concat(_list)
						} else {
							this.pRankList = _list
						}
          }
        })
      },
      getTeamScoreRank: function (addBr) {
				this.tStatus = 'loading'
				if (addBr) {
					this.TNum++
				} else {
					this.TNum = 1
				}
        const params = {
          pageNum: this.TNum,
          pageSize: this.TSize,
          platform: 'pc'
        }
        ApiGetTeamScoreRank(params).then(res=>{
          if (res.code == 200) {
            const _list = res.pc.details
						if (_list.length < this.TSize) {
							this.tStatus = 'noMore'
						} else {
							this.tStatus = 'more'
						}
						if (addBr) {
							this.tRankList = this.tRankList.concat(_list)
						} else {
							this.tRankList = _list
						}
          }
        })
      },
      load: function () {
        if (this.tableBr) {
          if (this.status == 'more') {
            this.getActivityScoreRank(true)
          }
        } else {
          if (this.tStatus == 'more') {
            this.getTeamScoreRank(true)
          }
        }
      }
    },
    mounted: function () {
      this.getMyScore()
      this.getMyTeamScore()
      this.getActivityScoreRank()
      this.getTeamScoreRank()
    }
  }
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px !important;
  height: 6px;
}
.ranking-container{
    width: 375px;
    height: 680px;
    background: linear-gradient(to right, #FE7832, #F01A15);
    overflow-y: auto;
    overflow-x: hidden;
    margin:0 auto;
  }
  .ranking-table{
    width: 375px;
    height:auto;
    margin: 0 auto;
    background-image: url(../../../assets/img/score-img-top.jpg);
    background-size: 375px 300px;
    background-repeat: no-repeat;
    overflow: hidden;
  }
  .ranking-table-content{
    width: 375px;
    background:#fff;
    border-radius: 10px 10px 0 0 ;
    height: auto;
    margin: 0 auto;
    margin-top: 125px;
    overflow: hidden;
    margin-bottom: 30px;
  }
  #tab1{
    width:340px;
    height:34px;
    border-bottom:0;
    margin: 0 auto;
    margin-top: 20px;
    }
  #tab1 ul{
    margin:0;
    padding:0;
    }
  #tab1 li{
    float:left;
    width: 118px;
    margin-left: 25px;
    margin-right: 25px;
    height:34px;
    line-height:34px;
    text-align:center;
    cursor:pointer;
    list-style-type: none;
    font-size: 16px;
    border-radius: 18px;
    border:1px solid #E50012;
    color: #E50012;

    }
  #tab1 li.now{
    color:#fff;
    background:#E50012;
    border-bottom: none;
    }
  .tablist{
    width:340px;
    margin: 0 auto;
    }
  .block{
    display:block;
    }
  .ranking-personal-table{
    width: 340px;
    overflow: hidden;
  }
  .ranking-personal-tables{
    width: 318px;
    overflow: hidden;
    background: #fff;
    padding: 15px 10px 15px 10px;
    float: left;
    border-radius: 10px;
    margin-top: 20px;
    box-shadow: 0 2px 6px  rgba(0, 0, 0, 0.05);
    border:1px solid #f1f1f1;
    margin-bottom: 20px;
  }
  .head-img{
    width: 40px;
    height: 40px;
    float: left;
    border-radius: 50%;
  }
  .ranking-personal-number{
    height: 48px;
    line-height:48px;
    float: left;
    font-size: 18px;
    margin-right: 20px;
    color: #666;
    width: 36px;
    text-align: center;
  }
  .ranking-personal-text{
    float:left;
    margin-left: 10px;
  }
  .ranking-personal-name{
    float:left;
    font-size: 14px;
    margin-top: 1px;
    color: #333;
    margin-bottom: 2px;
  }
  .ranking-personal-department{
    float:left;
    color: #b2b2b2;
    margin-top: 1px;
    font-size: 12px;
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .ranking-personal-fraction{
    float: right;
    height: 48px;
    line-height: 48px;
    color: #C78F00;
    font-size: 16px;
    margin-right: 5px;
  }
  .ranking-personal-fraction span{
    font-size: 10px;
  }
  .ranking-personal-tabli{
    width: 600px;
    overflow: hidden;
  }
  .ranking-personal-tabli ul{
    margin:0;
    padding:0;
  }
  .ranking-personal-tabli ul li{
    list-style-type: none;
    width: 320px;
    float: left;
    padding: 10px 10px 10px 10px;
  }
  .ranking-top-one{
    height: 48px;
  }
  .ranking-top-two{
    height: 48px;
  }
  .ranking-top-three{
    height: 48px;
  }
  .mgr10{

  }
  .ranking-personal-company{
    height: 48px;
    line-height: 48px;
    color: #333;
    font-size:16px;
    width: 210px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    float: left;
  }
  .ranking-personal-comli{
    width: 600px;
    overflow: hidden;
  }
  .ranking-personal-comli ul{
    margin:0;
    padding:0;
  }
  .ranking-personal-comli ul li{
    list-style-type: none;
    padding:10px;
    width: 320px;
    float: left;
  }
  .ranking-container::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 6px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
    }
    .ranking-container::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    background   : #666666;
    border-radius: 0;
    }
    .ranking-container::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background   : #ededed;
    border-radius: 0;
    }
    .btn_back{
      position: absolute;
      left: 10px;
      top: 15px;

    }
    .btn_back img{
      width: 24px;
      cursor: pointer;
      margin:10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/children/ranking.vue